import { Languages } from "lucide-react";
import { setLocale, t, useLocale, type Locale } from "./locale";

export function LanguageSelect() {
  const locale = useLocale();
  return <label className="flex shrink-0 items-center gap-1.5 rounded-lg border border-[var(--border)] px-2 py-2 text-xs text-[var(--muted-foreground)]">
    <Languages size={16} aria-hidden="true" />
    <span className="sr-only">{t("Idioma do painel")}</span>
    <select aria-label={t("Idioma do painel")} value={locale} onChange={event => setLocale(event.target.value as Locale)} className="max-w-24 bg-[var(--card)] text-[var(--foreground)] outline-none focus-visible:ring-2 focus-visible:ring-[var(--ring)]">
      <option value="pt-BR" lang="pt-BR">Português</option>
      <option value="en-US" lang="en-US">English</option>
    </select>
  </label>;
}
